/*
  Reasons for shadow:
  - Get custom package data based on zip code submitted by user
*/

import { navigate } from 'gatsby'
import zipLogic from '../../../../../utils/zipLogic'

const availabilitySubmit = async ({ setIsSubmitted, setUserData, values }) => {
  /**
   * Reset data before fetching for new data, so that anything
   * watching `userData.getCenturylinkPackages` can show the appropriate
   * components (loading or packages).
   */
  setUserData({
    loading: true,
    frontierPackages: null,
  })
  const isSpanishPage = window.location.pathname.includes('/es')
  const packageData = await zipLogic(values.zip_postal, isSpanishPage)

  setUserData({
    loading: false,
    frontierPackages: packageData,
  })

  if (packageData?.packages?.length === 0) {
    if (window.location.pathname.includes('/es')) {
      navigate('/es/disponibilidad/fuera-del-area')
    } else {
      navigate('/availability/out-of-area')
    }
  } else if (window.location.pathname.includes('/es')) {
    navigate('/es/disponibilidad/en-el-area')
  } else {
    navigate('/availability/in-area')
  }

  return setIsSubmitted(true)
}

export default availabilitySubmit
